import { Section } from 'components/section'
import { Animation } from './animation'
import { Light } from 'styles/typography'
import ContactInfo from 'components/contact-info'
import { ChapterFooter } from 'components/layout/chapter-footer'
import { authors } from './footer-data'

import DataWrapperChart from 'components/datawrapper'
import ChordDiagram from './chord-diagram'

import coloredTitleA_L from './images/ColoredTitle3A_L.webp'
import coloredTitleA_M from './images/ColoredTitle3A_M.webp'
import coloredTitleA_S from './images/ColoredTitle3A_S.webp'
import coloredTitleB_L from './images/ColoredTitle3B_L.webp'
import coloredTitleB_M from './images/ColoredTitle3B_M.webp'
import coloredTitleB_S from './images/ColoredTitle3B_S.webp'
import coloredTitleC_L from './images/ColoredTitle3C_L.webp'
import coloredTitleC_M from './images/ColoredTitle3C_M.webp'
import coloredTitleC_S from './images/ColoredTitle3C_S.webp'
import { ColoredTitle } from 'components/colored-title'
import { ParallaxImage } from './parallax/parallax-image'

export const Tajikistan = () => {
  return (
    <>
      <Animation />
      <Section containerType="text">
        <p>
          Тахмину (имя изменено) выдали замуж в 17 лет, едва она окончила школу.
          Женихом оказался успешный бизнесмен из Душанбе, из состоятельной
          семьи.
        </p>
        <p>
          Еще в детстве Тахмина мечтала о любви и семейном счастье. Позже все
          вроде бы сложилось: она вышла замуж, переехала в уютный дом, рядом был
          обеспеченный муж.
        </p>
        <p>
          Но за яркой ширмой прятался страх, а и без того тихий голос девушки
          постоянно заглушали упреки и крики в месте, которое она не могла
          назвать домом.
        </p>
        <p>
          <Light>
            Предупреждение: в материале присутствуют описания сцен насилия
          </Light>
        </p>
        <p>
          Этот материал – часть проекта{' '}
          <a
            href="https://voicesofthebrave.asia/"
            target="_blank"
            rel="noreferrer"
          >
            "Голоса смелых"
          </a>{' '}
          , посвященного гендерному насилию в Центральной Азии. Мы рассказываем
          истории женщин, переживших насилие, чтобы показать масштаб проблемы и
          дать голос тем, кто зачастую говорить не может.
        </p>
      </Section>
      <Section
        containerType="text"
        heading='"Почему ты вышла на улицу, не спросив меня?"'
      >
        <p>
          После свадьбы Тахмина с мужем поселилась в его родительском доме –
          семья оказалась очень традиционной. Девушка стала келин – так называют
          невесток в Центральной Азии. Дословно слово переводится как "пришлая"
          или "пришедшая из другой семьи". Вместе с новым статусом на девушек
          падает и вся физическая работа по дому.
        </p>
        <p>
          Пока муж, свекровь и золовка спали, Тахмина вставала в пять утра и
          успевала подмести двор, убраться и приготовить завтрак. Каждый вечер
          она ложилась позже всех, чтобы помыть полы и приготовить тесто для
          лепешек на следующий день.
        </p>
        <p>
          Тахмина рассказывает, что ее жизнь превратилась в бесконечный список
          обязанностей.
        </p>
        <p>
          Традиция, согласно которой невеста после свадьбы выполняет домашние
          обязанности в семье мужа, называется в Таджикистане "хизмати келин".
          Это дословно переводится как "служба невесты".
        </p>
        <p>
          Такая практика делает молодых девушек более уязвимыми: важно делать
          все быстро и безупречно, чтобы избежать замечаний со стороны свекрови
          и других членов новой семьи.
        </p>
        <p>
          "Ты слишком медленно моешь посуду. Почему твой плов такой сухой?
          Почему ты вышла на улицу не спросив меня?" – такие фразы стали
          повседневностью Тахмины.
        </p>
        <p>
          "Однажды я порезала хлеб "неправильно", – вспоминает Тахмина. –
          Свекровь начала кричать, что я ничего не умею, я бесполезная и что мой
          брак – это моя единственная удача в жизни".
        </p>
        <p>
          Новая жизнь напоминала Тахмине бесконечный экзамен, когда "любое
          действие оценивается и критикуется свекровью". Она сравнивает это
          состояние с жизнью в клетке.
        </p>
        <p>
          "После замужества меня год не пускали навестить своих родителей и
          долгое время я виделась с ними, только если они приходили к нам домой.
          Я не ходила даже в гости к кому-то," – вспоминает Тахмина. Любое ее
          действие нуждалось в разрешении – мужа, свекрови, даже золовки.
        </p>
        <p>
          Сначала Тахмина пыталась смириться: избегала конфликтов, отказывалась
          от встреч с подругами, надеялась, что если заслужит расположение семьи
          мужа, все изменится. Но критика и запреты только усиливались.
        </p>
        <p>
          "Самое обидное – это то, как они выставляли наши недопонимания
          наихудшим образом перед мужем", – говорит она.
        </p>
        <p>
          Муж Тахмины наблюдал молча и редко вставал на ее защиту. "Он говорил
          мне: "Это всего лишь традиции. Потерпи немного, мама привыкнет". Но я
          не понимала, сколько это "немного" может длиться", – говорит она.
        </p>
      </Section>

      <ColoredTitle src={[coloredTitleA_S, coloredTitleA_M, coloredTitleA_L]} />

      <Section containerType="text">
        <p>
          Поделиться своими чувствами было не с кем. "Ты должна быть сильной и
          уметь справляться с трудностями, у всех бывают недопонимания со
          свекровью, но ничего, люди живут", – повторяла ей мать. В культуре,
          где считается, что женщина должна быть терпеливой и покорной,
          выражение недовольства воспринимается как слабость или даже позор.
          Поэтому, опасаясь осуждения со стороны других, Тахмина закрылась в
          себе и молчала о своем состоянии.
        </p>
      </Section>
      <Section
        containerType="text"
        heading='"Может, с тобой что-то не так? Другие рожают, а ты не можешь"'
      >
        <p>
          За первые два года брака Тахмина пережила два выкидыша. Она винила
          себя в случившемся, хотя в глубине души понимала, что ее тело просто
          не выдержало нагрузки: во время беременности от нее требовали
          выполнения всех тех же обязанностей по дому.
        </p>
        <p>
          Поэтому разговоры о беременности и вопросы о том, когда она родит,
          были для нее особенно тяжелыми.
        </p>
        <p>
          Отношения с родственниками мужа стали более натянутыми. Муж молчал,
          избегая разговоров, а свекровь и золовка открыто выражали свое
          недовольство. "Может, с тобой что-то не так? Другие рожают, а ты не
          можешь", – говорила не раз ей свекровь.
        </p>
        <p>
          "Меня никто не бил, но надо мной постоянно издевались. Сейчас я
          осознаю, что тогда я сталкивалась с некой эксплуатацией и
          систематическим психологическим насилием со стороны мужа, свекрови и
          своей золовки", – говорит Тахмина.
        </p>
        <p>
          В традиционных таджикских семьях бесплодие или выкидыши часто
          воспринимаются как вина женщины, независимо от реальных медицинских
          причин. Это может сопровождаться постоянным моральным давлением и
          унижениями.
        </p>
        <p>
          В Центральной Азии беременность – главный признак успешного брака и
          выполнения женской роли. От женщины ждут, что она быстро станет
          матерью. Отсутствие беременности вызывает осуждение в обществе.
          Зачастую женщину обвиняют в бесплодии даже если дело не в ней. Это
          усиливает эмоциональное и психологическое давление.
        </p>
        <p>
          На третий год брака Тахмина снова забеременела, но отношения в семье
          продолжали ухудшаться: напряжение со свекровью и золовкой росло, а муж
          либо игнорировал конфликты, либо вставал на сторону своей матери.
          Тахмина все чаще испытывала отчаяние, разочарование и беспомощность.
        </p>
        <p>
          "Муж не мог ударить меня потому, что я была беременна, но он мог
          закатывать долгие истерики, кричать и оскорблять меня. В порыве гнева
          мог порвать платья, которые мне подарили родители, швырять мои вещи
          или еду, которую я ему приносила. За каждой ссорой следовали запреты,
          например, не разговаривать с родителями, не выходить из дома или и
          вовсе не смотреть телевизор и не использовать телефон", – вспоминает
          Тахмина.
        </p>

        <ParallaxImage />

        <p>
          Спустя некоторое время у Тахмины родилась долгожданная дочка. Но
          контроль и скандалы продолжались. Согласно таджикским традициям,
          рождение первого ребенка часто становится важным этапом в жизни келин.
          Если первенец – мальчик, статус невестки в семье может повыситься.
        </p>
        <p>
          Она не могла навестить родителей без разрешения или даже сходить в
          магазин одна. Однажды она хотела встретиться с подругой, но в итоге
          пришлось остаться дома – из-за этого она плакала в ванной, чтобы никто
          не услышал.
        </p>
        <p>
          Тахмина рассказывает, что в традиционной таджикской семье свекровь
          часто имеет решающее слово в вопросах, касающихся не только домашнего
          хозяйства, но и жизни молодой пары.
        </p>
        <p>
          "Отклонение от традиций или неподчинение старшей женщине
          воспринимается как угроза семейному укладу. Сами мужья часто не могут
          противостоять давлению своих матерей, так как зависят от них,
          оставаясь под одной крышей", – отмечает Тахмина.
        </p>
      </Section>
      <Section
        containerType="text"
        heading='"Свобода начинается с новых границ"'
      >
        <p>
          После четырех лет бесконечных конфликтов Тахмина убедила мужа
          переехать в отдельное жилье. Ей не терпелось начать новую жизнь с
          мужем и дочкой по своим правилам, без постоянного вмешательства. Но
          свекровь все так же оставалась центральной фигурой в их отношениях.
        </p>
        <p>
          "Она могла прийти в любой момент, без предупреждения, – вспоминает
          Тахмина, – Просто открывала дверь своим ключом и заходила, как будто
          это ее дом. Иногда начинала давать указания, что мне нужно приготовить
          на ужин или как растить ребенка. Это было удушающе".
        </p>
        <p>
          Однако переезд впервые помог ей задуматься о том, как на нее повлияли
          годы, проведенные в доме родителей мужа. Она вспоминает, что на новом
          месте продолжала жить теми же ожиданиями, страхами и с чувством
          контроля.
        </p>
        <p>
          Тахмина часто испытывала чувство вины, если ее дом не выглядел
          идеально или если она готовила блюда, которые не одобрила бы свекровь.
          Она все время ждала, что кто-то неожиданно появится с претензиями.
        </p>
        <p>
          "Я поняла, что свобода начинается не с новой квартиры, а с новых
          границ, – говорит Тахмина. – Но установить их оказалось не так просто,
          когда ты всю жизнь прожила, угождая другим".
        </p>
      </Section>

      <ColoredTitle src={[coloredTitleB_S, coloredTitleB_M, coloredTitleB_L]} />

      <Section containerType="text">
        <p>
          Построить здоровые отношения с мужем тоже не получалось: он все чаще
          задерживался на работе и общался только по бытовым вопросам.
        </p>
        <p>
          Однажды Тахмина вышла на улицу гулять с дочкой. Придя домой, она
          увидела свою свекровь, которая придирчиво осматривала квартиру,
          критиковала уборку и кричала, что, живя отдельно, она совсем
          распустилась.
        </p>
        <p>
          Когда Тахмина начала спорить и объясняться, свекровь заявила, что та
          "плохая жена и мать" и "не уважает старших". Муж Тахмины вернулся,
          когда ссора уже разгорелась. Он встал на сторону матери.
        </p>
        <p>
          Для Тахмины это стало последней каплей. "Я просто взяла дочку и ушла в
          летнем поплине, не взяв никакие свои вещи", – вспоминает Тахмина.
        </p>
      </Section>
      <Section
        containerType="text"
        heading="Психологическое насилие часто сопровождает и другие его формы"
      >
        <p>
          По оценке ООН, треть женщин в Таджикистане{' '}
          <a
            href="https://news.un.org/ru/story/2023/03/1438642"
            target="_blank"
            rel="noreferrer"
          >
            страдают
          </a>{' '}
          от домашнего насилия со стороны партнеров
        </p>
        <p>
          Согласно последнему{' '}
          <a
            href="https://iphronline.org/wp-content/uploads/2024/03/rus-tajikistan-dv-report-march-2024.pdf"
            target="_blank"
            rel="noreferrer"
          >
            исследованию
          </a>{' '}
          "Моя жизнь прекратилась после замужества", каждая вторая женщина в
          Таджикистане минимум раз в жизни подвергалась физическому,
          психологическому или экономическому насилию со стороны мужа,
          родственников супруга или других членов семьи.
        </p>
        <p>
          Пугает и другой вывод исследования: почти половина респондентов
          согласны с тем, что насилие в отношении женщин – это "личное дело
          каждой семьи, куда никто не должен вмешиваться", а около 41% считают
          избиение партнера допустимым по разным причинам.
        </p>
        <p>
          Кроме того, в Таджикистане самые высокие показатели ранних браков
          среди стран Центральной Азии: более 14% девочек в Таджикистане
          замужем, разведены или состоят в незарегистрированном браке.
        </p>
        <p>
          По данным Верховного суда, в 2022 году в Таджикистане более четырех
          тысяч несовершеннолетних (в основном девушки) получили{' '}
          <a
            href="https://rus.ozodi.org/a/32789806.html"
            target="_blank"
            rel="noreferrer"
          >
            разрешение
          </a>{' '}
          на вступление в брак.
        </p>
        <p>
          В Таджикистане нет открытых и подробных данных по домашнему насилию, а
          сама тема табуирована в обществе. Поэтому важно опираться на
          альтернативные источники информации, включая независимые опросы.
        </p>
        <p>
          Одним из таких источников был опрос, проведенный в рамках проекта
          "Голоса смелых". Хотя и не является полноценным социологическим
          исследованием, он дал нам понимание некоторых важных вещей. Например,
          согласно опроснику, наиболее распространенной формой насилия оказалось
          психологическое – его отметили 135 женщин из Таджикистана. Всего в нем
          приняли участие 219 респондентов из Таджикистана, большая часть из
          которых женщины.
        </p>
        <DataWrapperChart
          title="Респондентки из Таджикистана чаще всего переживали психологическое насилие"
          ariaLabel="Bar Chart"
          id="datawrapper-chart-QwFSp"
          src="https://datawrapper.dwcdn.net/QwFSp/4/"
          height="391px"
        />
        {/*<iframe title="(Data-viz) Респондентки из Таджикистана чаще всего переживали психологическое насилие" aria-label="Bar Chart" id="datawrapper-chart-QwFSp" src="https://datawrapper.dwcdn.net/QwFSp/4/" scrolling="no" frameborder="0" style="width: 0; min-width: 100% !important; border: none;" height="391" data-external="1"></iframe><script type="text/javascript">!function(){"use strict";window.addEventListener("message",(function(a){if(void 0!==a.data["datawrapper-height"]){var e=document.querySelectorAll("iframe");for(var t in a.data["datawrapper-height"])for(var r,i=0;r=e[i];i++)if(r.contentWindow===a.source){var d=a.data["datawrapper-height"][t]+"px";r.style.height=d}}}))}();</script>*/}
        <p>
          Однако важно отметить, что психологическое насилие часто
          сопровождается другими его видами. Так, 40 женщин сообщили, что
          сталкивались одновременно с психологическим и физическим насилием, а
          еще 28 – с сочетанием психологического, физического и
          сексуализированного насилия.
        </p>
        <ChordDiagram />
      </Section>
      <Section containerType="text">
        <p>
          Даже после случившегося конфликта, покинув дом, Тахмина не хотела
          разводиться с мужем. Она говорит, что все еще верила, что он
          изменится, начнет ценить ее и семью, которую они построили. Но спустя
          год ожиданий родители все же уговорили ее развестись и взять жизнь в
          свои руки.
        </p>
        <p>
          "Мне было страшно, – говорит она. – Разведенная женщина, особенно с
          ребенком, – это клеймо в нашем обществе. Но я поняла, что жить в
          постоянной эмоциональной пустоте еще страшнее".
        </p>
        <p>
          Тахмина начала постепенно восстанавливать себя, возвращаясь к тому,
          что она утратила в браке. Девушка поступила в университет на заочное
          отделение и параллельно работала продавщицей. После жизни в
          традиционной семье в качестве келин ей хотелось независимости, поэтому
          она старалась не брать деньги у своих родителей.
        </p>
        <p>
          Получив высшее образование, она устроилась работать на госслужбу. В
          свободное время она путешествует – они с дочкой посетили несколько
          стран, включая ОАЭ и Вьетнам.
        </p>
        <p>
          С бывшим мужем они не поддерживают отношения, он изредка видится с
          дочкой.
        </p>
        <p>
          Для многих женщин в Таджикистане замужество зачастую превращается в
          подавление. В традиционных семьях они ежедневно переживают разные
          формы насилия, особенно психологическое, часто исходящее от свекровей.
          Такое насилие – это невидимые шрамы: слова, упреки и манипуляции,
          которые ломают самооценку и психику человека.
        </p>
        <p>
          Статус келин является социально самым низким в семье, учитывая права и
          обязанности. Женщина сталкивается с множеством обязанностей и
          ограничений, которые не должны восприниматься обществом как норма,
          потому что они являются нарушением прав человека.
        </p>
      </Section>

      <ColoredTitle src={[coloredTitleC_S, coloredTitleC_M, coloredTitleC_L]} />

      <Section containerType="text">
        <p>
          Таджикистан{' '}
          <a
            href="https://mfa.tj/ru/main/view/6721/mezhdunarodnye-dogovory-respubliki-tadzhikistan-po-pravam-cheloveka"
            target="_blank"
            rel="noreferrer"
          >
            ратифицировал
          </a>{' '}
          несколько ключевых международных документов: Всеобщую декларацию прав
          человека, Конвенцию о ликвидации всех форм дискриминации в отношении
          женщин (CEDAW) и Конвенцию против пыток и других жестоких,
          бесчеловечных или унижающих достоинство видов обращения и наказания.
          Эти документы закрепляют право каждой женщины на жизнь, свободу и
          личное достоинство.
        </p>
        <p>
          Однако статус келин и связанные с ним "традиционные" практики, такие
          как выполнение хизмата, физическая грузка, психологическое насилие,
          полностью{' '}
          <a
            href="https://www.tandfonline.com/doi/abs/10.1080/02634937.2020.1850423?journalCode=ccas20"
            target="_blank"
            rel="noreferrer"
          >
            противоречат
          </a>{' '}
          этим обязательствам и нарушают базовые права женщин.
        </p>
        <p>
          Гендерная исследовательница Фарангис Давронова подчеркивает: "Статус
          келин и его практики не просто устаревшие – они незаконны. Они
          говорят, любая форма угнетения, будь то физическая или
          психологическая, не может быть оправдана культурой, права женщины –
          это не предмет для торга между традицией и современностью".
        </p>
      </Section>
      <ContactInfo />

      <ChapterFooter authors={authors} />
    </>
  )
}
